export default "__VITE_ASSET__CtJ825Ah__"